import { emailValidaotr } from 'common/utils/validator';

export const formSchema = {
  email: { value: '', errors: [], touched: false, validator: emailValidaotr }
};
